/* eslint-disable no-use-before-define */
import { gql } from "@apollo/client";

export const GET_PAYMENT_TOKENS = gql`
  query paymentTokens {
    paymentTokens {
      id
      token
      cardExpirationMonth
      cardExpirationYear
      lastFourDigits
      issuer
      expired
    }
  }
`;
